import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  MdUpload,
  MdLogout,
  MdDownload,
  MdRefresh,
  MdCloudUpload
} from "react-icons/md";
import { comensalApi } from "../../../services/api/comensalApi";
import { clienteApi } from "../../../services/api/clienteApi";
import * as XLSX from "xlsx";
import "react-toastify/dist/ReactToastify.css";

const CargaMasivaActivarComensales = () => {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
  
  // Estados
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedAccion, setSelectedAccion] = useState("activar");
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState(null);

  const showToast = (type, message) => {
    if (type === "success") {
      toast.success(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "error") {
      toast.error(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "info") {
      toast.info(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "warning") {
      toast.warning(message, { position: "bottom-right", autoClose: 3000 });
    }
  };

  // Cargar clientes del proyecto
  useEffect(() => {
    const fetchClientes = async () => {
      if (selectedProject && selectedProject.id) {
        try {
          const clientesResponse = await clienteApi.getByProyectoRest(selectedProject.id);
          
          let clientesData = [];
          if (clientesResponse.data && Array.isArray(clientesResponse.data)) {
            clientesData = clientesResponse.data;
          } else if (clientesResponse.data && clientesResponse.data.data && Array.isArray(clientesResponse.data.data)) {
            clientesData = clientesResponse.data.data;
          }
          
          setClientes(clientesData);
        } catch (error) {
          console.error("❌ Error cargando clientes:", error);
          showToast("error", "Error cargando clientes");
        }
      }
    };
    fetchClientes();
  }, [selectedProject?.id]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Validar extensión
      const validExtensions = ['.xlsx', '.xls'];
      const fileExtension = selectedFile.name.substring(selectedFile.name.lastIndexOf('.')).toLowerCase();
      
      if (!validExtensions.includes(fileExtension)) {
        showToast("error", "Por favor, selecciona un archivo Excel (.xlsx o .xls)");
        e.target.value = "";
        return;
      }
      
      setFile(selectedFile);
      setResults(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validaciones
    if (!selectedCliente) {
      showToast("error", "Por favor, selecciona un cliente");
      return;
    }

    if (!file) {
      showToast("error", "Por favor, selecciona un archivo Excel");
      return;
    }

    if (!selectedAccion) {
      showToast("error", "Por favor, selecciona una acción");
      return;
    }

    setIsLoading(true);
    setResults(null);

    try {
      const response = await comensalApi.activarInactivarMasivo(
        file,
        parseInt(selectedCliente),
        selectedAccion
      );

      if (response.data && response.data.success) {
        setResults(response.data.resumen);
        showToast("success", `Proceso completado: ${selectedAccion} comensales`);
      } else {
        showToast("error", "Error en el proceso");
      }
    } catch (error) {
      console.error('❌ Error en carga masiva:', error);
      
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        showToast("error", errorData.detail || errorData.message || "Error en el proceso");
      } else {
        showToast("error", "Error de conexión. Verifica tu conexión a internet.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const downloadTemplate = () => {
    // Crear template con una sola columna: número de documento de identidad
    const templateData = [
      { 'Número de Documento de Identidad': '12345678' },
      { 'Número de Documento de Identidad': '87654321' },
      { 'Número de Documento de Identidad': '11223344' }
    ];

    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");
    XLSX.writeFile(wb, "template_activar_inactivar_comensales.xlsx");
    
    showToast("success", "Plantilla descargada");
  };

  const resetForm = () => {
    setFile(null);
    setSelectedCliente("");
    setSelectedAccion("activar");
    setResults(null);
    const fileInput = document.getElementById('excel_file');
    if (fileInput) {
      fileInput.value = "";
    }
    showToast("info", "Formulario reiniciado");
  };

  return (
    <>
      {/* Digital Harmony Styles para Carga Masiva Activar/Inactivar Comensales */}
      <style>
        {`
          /* Estilos base Digital Harmony - Igual a CargaMasivaComensales */
          .dh-carga-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
          }
          
          .dh-card-main {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
          }
          
          .dh-card-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border-radius: 20px 20px 0 0;
            padding: 1.5rem 2rem;
            border: none;
          }
          
          .dh-header-title {
            color: white;
            font-weight: 700;
            font-size: 1.5rem;
            margin: 0;
          }
          
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(17, 153, 142, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-primary:hover {
            background: linear-gradient(135deg, #38ef7d 0%, #2dd4bf 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(17, 153, 142, 0.4);
            color: white;
          }
          
          .btn-dh-warning {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(240, 147, 251, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-warning:hover {
            background: linear-gradient(135deg, #f5576c 0%, #e91e63 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(240, 147, 251, 0.4);
            color: white;
          }
          
          .btn-dh-info {
            background: linear-gradient(135deg, #00c6ff 0%, #0072ff 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(0, 198, 255, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-info:hover {
            background: linear-gradient(135deg, #0072ff 0%, #0056cc 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(0, 198, 255, 0.4);
            color: white;
          }
          
          .btn-dh-secondary {
            background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 10px 16px;
            font-weight: 600;
            box-shadow: 0 4px 14px rgba(107, 114, 128, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-secondary:hover {
            background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4);
            color: white;
          }
          
          .dh-form-container {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            border-radius: 15px;
            padding: 2rem;
            margin-bottom: 1.5rem;
          }
          
          .form-label-dh {
            font-weight: 700;
            color: #374151;
            margin-bottom: 0.75rem;
            font-size: 0.95rem;
          }
          
          .form-select-dh, .form-control-dh {
            border: 2px solid #e5e7eb;
            border-radius: 12px;
            padding: 12px 16px;
            font-size: 1rem;
            transition: all 0.3s ease;
            background: white;
            box-shadow: 0 2px 4px rgba(0,0,0,0.02);
          }
          
          .form-select-dh:focus, .form-control-dh:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 0.25rem rgba(102, 126, 234, 0.15);
            background: white;
          }
          
          .dh-upload-section {
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
            border: 2px dashed #16a34a;
            border-radius: 15px;
            padding: 2.5rem;
            text-align: center;
            transition: all 0.3s ease;
            margin: 1.5rem 0;
          }
          
          .dh-upload-section:hover {
            border-color: #15803d;
            background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
            transform: translateY(-2px);
          }
          
          .dh-upload-section.has-file {
            border-color: #059669;
            background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
            box-shadow: 0 8px 25px rgba(16, 185, 129, 0.1);
          }
          
          .upload-icon {
            color: #16a34a;
            margin-bottom: 1rem;
          }
          
          .upload-text {
            color: #374151;
            font-size: 1.1rem;
            font-weight: 600;
            margin-bottom: 0.5rem;
          }
          
          .upload-subtext {
            color: #6b7280;
            font-size: 0.9rem;
            margin-bottom: 1.5rem;
          }
          
          .file-selected-display {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            color: white;
            padding: 12px 20px;
            border-radius: 12px;
            font-weight: 600;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin: 0.5rem;
            font-size: 1rem;
            box-shadow: 0 4px 14px rgba(5, 150, 105, 0.3);
            border: 2px solid #10b981;
            transition: all 0.3s ease;
            min-width: 180px;
            height: 44px;
          }
          
          .btn-file-uniform {
            padding: 12px 20px !important;
            border-radius: 12px !important;
            font-weight: 600 !important;
            font-size: 1rem !important;
            min-width: 180px !important;
            height: 44px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            margin: 0.5rem !important;
            transition: all 0.3s ease !important;
            box-shadow: 0 4px 14px rgba(0,0,0,0.2) !important;
          }
          
          .btn-submit-dh {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border: none;
            color: white;
            border-radius: 12px;
            padding: 14px 24px;
            font-weight: 700;
            font-size: 1.1rem;
            box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
            transition: all 0.3s ease;
            width: 100%;
            margin-top: 1.5rem;
          }
          
          .btn-submit-dh:hover:not(:disabled) {
            background: linear-gradient(135deg, #764ba2 0%, #8b5fbf 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
            color: white;
          }
          
          .btn-submit-dh:disabled {
            background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
            cursor: not-allowed;
            transform: none;
            box-shadow: none;
          }
          
          .dh-results-card {
            background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
            border: 2px solid #16a34a;
            border-radius: 20px;
            margin-top: 2rem;
            overflow: hidden;
            box-shadow: 0 10px 25px rgba(16, 185, 129, 0.1);
          }
          
          .dh-results-header {
            background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
            color: white;
            padding: 1.5rem 2rem;
            border-radius: 20px 20px 0 0;
          }
          
          .dh-results-body {
            padding: 2rem;
          }
          
          .dh-stat-card {
            background: white;
            border-radius: 15px;
            padding: 1.5rem;
            text-align: center;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
            transition: all 0.3s ease;
            border: 2px solid transparent;
          }
          
          .dh-stat-card:hover {
            transform: translateY(-3px);
            box-shadow: 0 8px 25px rgba(0,0,0,0.1);
            border-color: #667eea;
          }
          
          .stat-number {
            font-size: 2.5rem;
            font-weight: 800;
            margin-bottom: 0.5rem;
          }
          
          .stat-label {
            font-size: 0.9rem;
            font-weight: 600;
            color: #6b7280;
            text-transform: uppercase;
            letter-spacing: 0.05em;
          }
          
          .document-list {
            max-height: 200px;
            overflow-y: auto;
            padding: 10px;
            background-color: #f5f5f5;
            border-radius: 4px;
            margin-top: 10px;
          }
          
          .document-badge {
            display: inline-block;
            margin: 5px;
            padding: 5px 10px;
            border-radius: 4px;
            font-weight: 600;
          }
        `}
      </style>
      
      <div className="dh-carga-bg">
        <div className="container-fluid py-4">
          <ToastContainer />
          <div className="dh-card-main">
            <div className="dh-card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="dh-header-title">Carga Masiva - Activar/Inactivar Comensales</h5>
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn-dh-info d-flex align-items-center gap-2"
                    onClick={downloadTemplate}
                    title="Descargar plantilla Excel"
                  >
                    <MdDownload size={20} />
                    Descargar Template
                  </button>
                  <button
                    type="button"
                    className="btn-dh-warning d-flex align-items-center gap-2"
                    onClick={resetForm}
                    disabled={isLoading}
                    title="Limpiar formulario"
                  >
                    <MdRefresh size={20} />
                    Limpiar
                  </button>
                  <button 
                    className="btn-dh-secondary d-flex align-items-center gap-2" 
                    onClick={() => navigate("/home")}
                    title="Volver al inicio"
                  >
                    <MdLogout size={20} />
                    Cerrar
                  </button>
                </div>
              </div>
            </div>

            <div className="card-body" style={{ padding: '2rem' }}>
              <form onSubmit={handleSubmit}>
                <div className="dh-form-container">
                  <div className="row">
                    {/* Selección de Cliente */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="id_cliente" className="form-label-dh">
                        Cliente <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select-dh"
                        id="id_cliente"
                        value={selectedCliente}
                        onChange={(e) => setSelectedCliente(e.target.value)}
                        required
                        disabled={isLoading}
                      >
                        <option value="">Seleccione un cliente</option>
                        {clientes.map((cliente) => (
                          <option key={cliente.id} value={cliente.id}>
                            {cliente.nombre || cliente.nombre_cliente}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Selección de Acción */}
                    <div className="col-md-6 mb-4">
                      <label htmlFor="accion" className="form-label-dh">
                        Acción <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select-dh"
                        id="accion"
                        value={selectedAccion}
                        onChange={(e) => setSelectedAccion(e.target.value)}
                        required
                        disabled={isLoading}
                      >
                        <option value="activar">Activar</option>
                        <option value="desactivar">Desactivar</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Archivo Excel */}
                <div className="row">
                  <div className="col-12">
                    <label className="form-label-dh">
                      Archivo Excel <span className="text-danger">*</span>
                    </label>
                    
                    {/* Información sobre formato */}
                    <div className="alert alert-info mb-3" style={{ 
                      backgroundColor: '#e7f3ff', 
                      border: '1px solid #b3d9ff', 
                      borderRadius: '8px',
                      padding: '1rem'
                    }}>
                      <strong>📋 Formato del archivo Excel:</strong>
                      <p className="mb-2 mt-2">El archivo debe tener <strong>una sola columna</strong> con el número de documento de identidad:</p>
                      <ul style={{ paddingLeft: '1.5rem' }}>
                        <li><strong>Número de Documento de Identidad</strong> <span className="text-danger">(requerido)</span></li>
                      </ul>
                      <div className="alert alert-warning mt-3" style={{backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '8px', padding: '0.75rem'}}>
                        <small>
                          <strong>Importante:</strong> El archivo debe contener solo una columna con el número de documento de identidad de cada comensal. 
                          Use el template para asegurar el formato correcto.
                        </small>
                      </div>
                    </div>
                    
                    <div className={`dh-upload-section ${file ? 'has-file' : ''}`}>
                      <MdCloudUpload size={64} className="upload-icon" />
                      <input
                        type="file"
                        id="excel_file"
                        accept=".xlsx,.xls"
                        onChange={handleFileChange}
                        required
                        disabled={isLoading}
                        style={{ display: 'none' }}
                      />
                      {!file ? (
                        <>
                          <div className="upload-text">Seleccione su archivo Excel</div>
                          <div className="upload-subtext">Formatos soportados: .xlsx, .xls</div>
                          <label 
                            htmlFor="excel_file" 
                            className="btn-dh-primary btn-file-uniform" 
                            style={{ cursor: isLoading ? 'not-allowed' : 'pointer' }}
                          >
                            <MdUpload size={20} className="me-2" />
                            Examinar Archivos
                          </label>
                        </>
                      ) : (
                        <>
                          <div className="upload-text">Archivo seleccionado</div>
                          <div className="upload-subtext">
                            <strong>Archivo cargado:</strong>
                          </div>
                          <div className="d-flex flex-column align-items-center">
                            <div className="file-selected-display">
                              <i className="fas fa-check-circle me-2"></i>
                              {file.name}
                            </div>
                            <button
                              type="button"
                              className="btn-dh-warning btn-file-uniform"
                              onClick={() => {
                                setFile(null);
                                setResults(null);
                                const fileInput = document.getElementById('excel_file');
                                if (fileInput) {
                                  fileInput.value = '';
                                }
                              }}
                              disabled={isLoading}
                            >
                              <i className="fas fa-times me-2"></i>
                              Cambiar Archivo
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Botón de envío */}
                <button
                  type="submit"
                  className="btn-submit-dh d-flex align-items-center justify-content-center gap-2"
                  disabled={isLoading || !file || !selectedCliente || !selectedAccion}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Procesando archivo...
                    </>
                  ) : (
                    <>
                      <MdUpload size={24} />
                      {selectedAccion === 'activar' ? 'Activar Comensales' : 'Inactivar Comensales'}
                    </>
                  )}
                </button>
              </form>

              {/* Resultados */}
              {results && (
                <div className="dh-results-card">
                  <div className="dh-results-header">
                    <h5 className="mb-0 fw-bold">
                      <i className="fas fa-chart-bar me-2"></i>
                      Resultados del Proceso
                    </h5>
                  </div>
                  <div className="dh-results-body">
                    {/* Primera fila - Total */}
                    <div className="row mb-3">
                      <div className="col-md-12">
                        <div className="dh-stat-card" style={{backgroundColor: '#f8f9fa', border: '2px solid #dee2e6'}}>
                          <div className="stat-number text-primary" style={{fontSize: '3rem'}}>{results.total}</div>
                          <div className="stat-label" style={{fontSize: '1.1rem', fontWeight: 'bold'}}>TOTAL PROCESADOS</div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Segunda fila - Detalles */}
                    <div className="row">
                      <div className="col-md-4 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-success">{results.procesados_count || 0}</div>
                          <div className="stat-label">Actualizados</div>
                        </div>
                      </div>
                      <div className="col-md-4 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-danger">{results.no_encontrados_count || 0}</div>
                          <div className="stat-label">No Encontrados</div>
                        </div>
                      </div>
                      <div className="col-md-4 mb-4">
                        <div className="dh-stat-card">
                          <div className="stat-number text-info">{results.sin_cambios_count || 0}</div>
                          <div className="stat-label">Sin Cambios</div>
                        </div>
                      </div>
                    </div>

                    {/* Enlaces para descargar detalles */}
                    <div className="row mt-4">
                      {results.procesados && results.procesados.length > 0 && (
                        <div className="col-md-6 mb-3">
                          <button
                            type="button"
                            className="btn-dh-primary w-100 d-flex align-items-center justify-content-center gap-2"
                            onClick={() => {
                              const data = results.procesados.map(doc => ({ 'Número de Documento': doc }));
                              const ws = XLSX.utils.json_to_sheet(data);
                              const wb = XLSX.utils.book_new();
                              XLSX.utils.book_append_sheet(wb, ws, "Actualizados");
                              XLSX.writeFile(wb, `comensales_actualizados_${new Date().toISOString().split('T')[0]}.xlsx`);
                              showToast("success", "Archivo Excel descargado");
                            }}
                          >
                            <MdDownload size={20} />
                            Descargar Actualizados ({results.procesados.length})
                          </button>
                        </div>
                      )}
                      {results.no_encontrados && results.no_encontrados.length > 0 && (
                        <div className="col-md-6 mb-3">
                          <button
                            type="button"
                            className="btn-dh-warning w-100 d-flex align-items-center justify-content-center gap-2"
                            onClick={() => {
                              const data = results.no_encontrados.map(doc => ({ 'Número de Documento': doc }));
                              const ws = XLSX.utils.json_to_sheet(data);
                              const wb = XLSX.utils.book_new();
                              XLSX.utils.book_append_sheet(wb, ws, "No Encontrados");
                              XLSX.writeFile(wb, `comensales_no_encontrados_${new Date().toISOString().split('T')[0]}.xlsx`);
                              showToast("success", "Archivo Excel descargado");
                            }}
                          >
                            <MdDownload size={20} />
                            Descargar No Encontrados ({results.no_encontrados.length})
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CargaMasivaActivarComensales;
